import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { finalize } from 'rxjs';
import { AuthService } from '../../../core/services/auth.service';
import { I18nService } from '../../../core/services/i18n.service';
import { NotificationService } from '../../../core/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { PermissionService } from '../../../core/services/permission.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, TranslateModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  mode: 'email' | 'otp' = 'email';
  email = '';
  password = '';
  phone = '';
  otp = '';
  loading = false;

  constructor(
    private readonly authService: AuthService,
    private readonly permissions: PermissionService,
    private readonly notifications: NotificationService,
    private readonly i18n: I18nService,
    private readonly translate: TranslateService,
    private readonly router: Router
  ) {}

  get localeLabel(): string {
    return this.i18n.currentLocale.toUpperCase();
  }

  toggleLocale(): void {
    this.i18n.toggleLocale();
  }

  submit(): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    const request =
      this.mode === 'email'
        ? this.authService.loginWithPassword(this.email.trim(), this.password)
        : this.authService.loginWithOtp(this.phone.trim(), this.otp.trim());

    request
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(() => {
        this.permissions.clear();
        this.notifications.success(this.translate.instant('auth.messages.welcome'));
        this.router.navigateByUrl('/dashboard');
      });
  }

  sendOtp(): void {
    const phone = this.phone.trim();
    if (!phone || this.loading) {
      return;
    }

    this.loading = true;
    this.authService
      .requestOtp(phone)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(() => {
        this.notifications.info(this.translate.instant('auth.messages.otpSent'));
      });
  }
}
